import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {ProductSelectionViewProps} from '../ProductSelection/ProductSelectionView';
import {useProductSelectionSection} from '../useGetProductBulkSection';
import {ProductSelectionQuickViewLoading} from './ProductSelectionQuickViewLoading';
import {ProductSelectionQuickViewView} from './ProductSelectionQuickViewView';

export const ProductSelectionQuickView: React.FC<
  ProductSelectionViewProps
> = props => {
  return (
    <DataFetcher
      request={useProductSelectionSection()}
      Error={null}
      Loading={() => (
        <ProductSelectionQuickViewLoading className={props.className} />
      )}
      View={ProductSelectionQuickViewView}
      viewProps={props}
    />
  );
};
